module.exports = __webpack_public_path__ + "static/media/BannnerARCHIMATE.a1ff9f7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Archimate/BannnerARCHIMATE.png
// module id = 111
// module chunks = 0